export enum TipoPortariaEnum {

  PortariaHabilitacao = 1,
  PortariaHabilitacaoProvisoria = 2,
  PortariaPpb = 3,
  PortariaCancelamento = 4,
  PortariaTrocaPpbPdi = 5,
  PortariaPontuacao = 6,
  PortariaEtapas = 7,

}
